import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    assignment: {},
    openModal: false
};

const assignmentsSlice = createSlice({
    name: "assignments",
    initialState,
    reducers: {
        editAssignment: (state, action) => {
            state.assignment = action.payload;
        },
        toggleModal: (state, action) => {
            state.openModal = action.payload
        }
    },
});

export const { editAssignment, toggleModal } = assignmentsSlice.actions;
export default assignmentsSlice.reducer;
